import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const path = location.pathname;
    const items = [
      { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' }
    ];

    switch (path) {
      case '/allocated-members-management':
        items.push({ label: 'Allocated Members', path: '/allocated-members-management', icon: 'Users' });
        break;
      case '/unallocated-members-management':
        items.push({ label: 'Unallocated Members', path: '/unallocated-members-management', icon: 'UserX' });
        break;
      case '/required-services-management':
        items.push({ label: 'Required Services', path: '/required-services-management', icon: 'ClipboardList' });
        break;
      case '/add-edit-member':
        items.push({ label: 'Add/Edit Member', path: '/add-edit-member', icon: 'UserPlus' });
        break;
      case '/reports':
        items.push({ label: 'Reports', path: '/reports', icon: 'ChartBar' });
        break;
      case '/allocation-stats':
        items.push({ label: 'Allocation Stats', path: '/allocation-stats', icon: 'LayoutGrid' });
        break;
      case '/manage':
        items.push({ label: 'Manage Services', path: '/manage', icon: 'Users' });
        break;
      default:
        break;
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();
  const isLoginPage = location.pathname === '/login-screen';
  const isDashboard = location.pathname === '/dashboard';

  if (isLoginPage || isDashboard) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 pt-0 pb-4 px-4 lg:px-6 bg-background border-b border-border mt-20">
      <div className="flex items-center space-x-2 text-sm">
        {breadcrumbItems.map((item, index) => (
          <React.Fragment key={item.path}>
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground" 
              />
            )}
            
            {index === breadcrumbItems.length - 1 ? (
              // Current page - not clickable
              <div className="flex items-center space-x-1 text-foreground font-medium">
                <Icon name={item.icon} size={16} className="text-primary" />
                <span>{item.label}</span>
              </div>
            ) : (
              // Previous pages - clickable
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(item.path)}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2"
              >
                <Icon name={item.icon} size={16} className=' mr-2'/>
                <span>{item.label}</span>
              </Button>
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;